import { Reveal } from "./Reveal";

export const Chapter = ({ number, kicker, title, id }) => (
  <div id={id} className="relative scroll-mt-28">
    <span
      aria-hidden="true"
      className="pointer-events-none select-none absolute -top-16 -left-2 md:-left-10 font-serif text-[10rem] md:text-[16rem] leading-none text-champagne/40"
    >
      {number}
    </span>
    <div className="relative">
      <Reveal>
        <p className="overline-label" data-testid={`chapter-${number}-kicker`}>{kicker}</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-4 font-serif text-5xl md:text-7xl font-medium tracking-tight text-burgundy" data-testid={`chapter-${number}-title`}>
          {title}
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-10 h-px w-24 bg-champagne" />
      </Reveal>
    </div>
  </div>
);
